import * as React from 'react';
import * as ReactDOM from 'react-dom';
import 'semantic-ui-css/semantic.css';
import App from './App';
import './css/AmplifierLabelTable.css';
import './css/App.css';
import './css/BufferForm.css';
import './css/CartPage.css';
import './css/CatalogPage.css';
import './css/CishAndFishHeader.css';
import './css/CornerLogoContainer.css';
import './css/DateRangePicker.css';
import './css/EditKitForm.css';
import './css/index.css';
import './css/KitIndexHeader.css';
import './css/NewConsumerRnaCishKitPage.css';
import './css/ProEditKitForm.css';
import './css/ProfileEditForm.css';
import './css/QuoteDisplay.css';
import './css/shared.css';
import './css/ViewShipmentPhotos.css';
import './css/webfonts.css';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
    <App />,
    document.getElementById('root') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx